module.exports = __webpack_public_path__ + "img/server-alt.30f05b40.svg";